module.exports = __webpack_public_path__ + "img/Einheit_für_Psychosoziale_Notfallversorgung.03009de1.svg";